import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';

import { HelpComponent } from './help.component';
import { SupportedBrowsersComponent } from './supported-browsers/supported-browsers.component';
import { ContactComponent } from './contact/contact.component';
import { UnsupportedBrowserComponent } from './unsupported-browser/unsupported-browser.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';

@NgModule({
  declarations: [
    HelpComponent,
    SupportedBrowsersComponent,
    ContactComponent,
    UnsupportedBrowserComponent,
    MaintenanceComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    UnsupportedBrowserComponent
  ]
})
export class HelpModule { }
